import { useNavigate } from 'react-router-dom';

interface CompanyLayoutProps {
    isNew: boolean;
    activeTab: string;
    onTabChange: (tab: string) => void;
    children: React.ReactNode;
}

const CompanyLayout = ({ isNew, activeTab, onTabChange, children }: CompanyLayoutProps) => {
    const navigate = useNavigate();

    return (
        <div className="main flex-1">
            <section className="updatebasicinformation">
                <div className="container max-1140 px-lg-0 overflow-hidden">
                    <div className="row">
                        <div className="col-md-12 mb-4">
                            <div className="white-block white-block-notopborderradius p-0 h-100">
                                <div className="border-bottom border-2 custom-border-gray p-3 p-sm-4 pb-3">
                                    <div className="d-flex flex-wrap justify-content-between align-items-center mx-0 mx-sm-1">
                                        <h1 className="font-26 font-600 my-0 my-sm-1 py-2">
                                            {isNew ? 'Add New Company' : 'Edit Company'}
                                        </h1>
                                        <button
                                            type="button"
                                            className="btn btn-outline-secondary btn-sm"
                                            onClick={() => navigate('/company/listing')}>
                                            ← Back to Listing
                                        </button>
                                    </div>
                                </div>

                                <div className="job_internship_tab polartabsec radius-6">
                                    <div className="xscroll p-0">
                                        <ul className="nav nav-tabs" id="CompanyTab" role="tablist">
                                            <li className="nav-item" role="presentation">
                                                <button
                                                    className={`nav-link ${activeTab === 'basic-info' ? 'active' : ''}`}
                                                    type="button"
                                                    role="tab"
                                                    onClick={() => onTabChange('basic-info')}>
                                                    Basic Info
                                                </button>
                                            </li>
                                            <li className="nav-item" role="presentation">
                                                <button
                                                    className={`nav-link ${activeTab === 'balance-sheets' ? 'active' : ''}`}
                                                    type="button"
                                                    role="tab"
                                                    onClick={() => onTabChange('balance-sheets')}>
                                                    Balance Sheets
                                                </button>
                                            </li>
                                        </ul>
                                    </div>
                                </div>

                                <div className="row m-0 pt-4 mt-2 JobInternshipListing">
                                    <div className="flex-1 polarcontsec tab-content" id="CompanyTabContent">
                                        {children}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default CompanyLayout;
